import { render, staticRenderFns } from "./CheckoutTemplate.vue?vue&type=template&id=25b634d9&scoped=true&"
import script from "./CheckoutTemplate.vue?vue&type=script&lang=js&"
export * from "./CheckoutTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutTemplate.vue?vue&type=style&index=0&id=25b634d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b634d9",
  null
  
)

export default component.exports